import React from 'react'
import { StatUp, StatDown } from 'iconoir-react'

const OverviewCard = ({ label, icon, value, trend, trendValue, color = 'primary' }) => {
  const colorStyles = {
    primary: {
      iconBg: 'bg-gradient-to-br from-primary-500 to-primary-600',
      iconShadow: 'shadow-glow',
    },
    accent: {
      iconBg: 'bg-gradient-to-br from-accent-500 to-accent-600',
      iconShadow: 'shadow-glow-accent',
    },
    success: {
      iconBg: 'bg-gradient-to-br from-success-500 to-success-600',
      iconShadow: 'shadow-[0_0_20px_rgba(34,197,94,0.3)]',
    },
    warning: {
      iconBg: 'bg-gradient-to-br from-warning-500 to-warning-600',
      iconShadow: 'shadow-[0_0_20px_rgba(245,158,11,0.3)]',
    },
  };

  const currentColor = colorStyles[color] || colorStyles.primary;

  return (
    <div className="card-hover group">
      <div className="flex items-start justify-between">
        {/* Icon */}
        <div className={`
          w-14 h-14 rounded-2xl flex items-center justify-center
          ${currentColor.iconBg} ${currentColor.iconShadow}
          transition-transform duration-300 group-hover:scale-105
        `}>
          <img alt='icon' src={icon} className="w-7 h-7 brightness-0 invert" />
        </div>

        {/* Trend indicator */}
        {trend && (
          <div className={`
            flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-semibold
            ${trend === 'up'
              ? 'bg-success-100 text-success-600'
              : 'bg-danger-100 text-danger-600'
            }
          `}>
            {trend === 'up'
              ? <StatUp strokeWidth={2} className="w-3.5 h-3.5" />
              : <StatDown strokeWidth={2} className="w-3.5 h-3.5" />
            }
            <span>{trendValue}%</span>
          </div>
        )}
      </div>

      <div className="mt-5">
        <p className="text-sm font-medium text-surface-500 mb-1">{label}</p>
        <p className="text-3xl font-bold text-surface-800 tracking-tight">{value}</p>
      </div>
    </div>
  )
}

export default OverviewCard
